module.exports = "/_next/static/images/CollectionAPI@2x-d8333e31376f8cc3ce1a72be169d3a3d.webp";